export const AFFIRMATION_AUDIO_INTRO =
  'Atraigo cada día todo lo que necesito hacer saber o tener para lograr mi estado deseado.';

export const AFFIRMATION_AUDIO_OUTRO =
  'El universo está organizando y orquestando todo lo que necesito que ocurra creando el estado deseado.';

export const createAffirmationScript = (phrases = []) => {
  const cleanPhrases = phrases.map((phrase) => `${phrase || ''}`.trim()).filter(Boolean);
  return [AFFIRMATION_AUDIO_INTRO, ...cleanPhrases, AFFIRMATION_AUDIO_OUTRO].join('\n\n');
};

export const normalizePhrases = (phrases = []) =>
  phrases.map((phrase) => `${phrase || ''}`.replace(/\s+/g, ' ').trim());

export const validatePhrases = (phrases = []) => {
  const cleanPhrases = normalizePhrases(phrases).filter(Boolean);
  if (cleanPhrases.length < 3 || cleanPhrases.length > 6) {
    return 'Tenés que completar entre 3 y 6 frases.';
  }
  if (cleanPhrases.some((phrase) => phrase.length > 280)) {
    return 'Cada frase puede tener hasta 280 caracteres.';
  }
  return '';
};

export const getAudioStatusLabel = (status) => {
  switch (status) {
    case 'phrases_saved':
      return 'Frases guardadas';
    case 'recording_uploaded':
      return 'Audio cargado';
    case 'submitted_to_editor':
      return 'Enviado a edición';
    case 'skipped':
      return 'Omitido';
    case 'error':
      return 'Error';
    default:
      return 'Sin iniciar';
  }
};
